export default __webpack_public_path__ + "static/media/3C.4defbcf5.svg";